import { utc } from 'moment'

export const getDateTime = () => utc().format('YYYY-MM-DD HH:mm:ss')
export const getTimeStamp = () => utc().valueOf()
